module.exports = __webpack_public_path__ + "img/44@2x.e482fc56.png";